import * as React from 'react';

// Fieldguide "F" mark, inline so it takes `currentColor` like a Font Awesome icon (an <img>-referenced
// SVG can't). Sized 1em to match the FA icons it sits beside in a .cr-btn__icon slot. Used as the icon
// on the "Send to Fieldguide" button. Path traced from the Fieldguide mark in the Figma mock (node
// 8495:6437, file LcTth2sgEJ6uFC9DSWLt9A), ported from the Crunchafi.POC de-fieldguide-phase-1 reference.
export const FieldguideMark: React.FC<{ className?: string }> = ({ className }): React.ReactElement => (
    <svg
        className={className}
        width={'1em'}
        height={'1em'}
        viewBox={'0 0 20 20.0615'}
        fill={'currentColor'}
        xmlns={'http://www.w3.org/2000/svg'}
        aria-hidden={'true'}
    >
        <path
            fillRule={'evenodd'}
            clipRule={'evenodd'}
            d={'M20 10.0307L19.9991 10.1604C19.9299 15.6404 15.4796 20.0615 9.99993 20.0615C9.99372 20.0615 9.98758 20.0614 9.98137 20.0614H0V10.0307C0 4.49093 4.47711 1.35615e-05 9.99993 0H20V10.0307ZM17.4998 2.50763C9.2803 2.50764 2.60491 9.13919 2.5011 17.3593L2.49991 17.5537H3.49991C4.60446 17.5537 5.4825 16.6487 5.66447 15.5559C5.81005 14.6817 6.04973 13.8396 6.3724 13.04H12.2499C13.3544 13.04 14.2498 12.1417 14.2498 11.0338V10.0307H8.1321C9.93753 7.77177 12.538 6.17961 15.5081 5.68194C16.5975 5.4994 17.4998 4.61866 17.4998 3.5107V2.50763Z'}
        />
    </svg>
);
